<template>
  <svg :width="width" :height="height">
  </svg>
</template>

<script>
import * as d3 from "d3";
import d3tip from "d3-tip";

export default {
  mounted: function() {
    this.svg = d3.select(this.$el);

    this.tip = d3tip()
      .attr("class", "d3-tip")
      .offset([-10, 0])
      .html(function(d) {
        return (
          "<div><span style='color:white'>" +
          d.name +
          "</span></div>" +
          "<div><span>Value:</span> <span style='color:white'>" +
          d.value +
          "</span></div>"
        );
      });

    this.svg.call(this.tip);

    this.drawChart(this.xRange);
  },
  watch: {
    xRange: function(newXRange) {
      this.drawChart(newXRange);
    }
  },
  methods: {
    drawChart: function(xRange) {
      this.svg.selectAll("*").remove();
      let xScale = d3
        .scaleBand()
        .domain(this.data.map(d => d.name))
        .range(xRange);

      let yScale = d3
        .scaleLinear()
        .domain(this.yDomain)
        .range([0, 300]);
      let yAxis = d3.axisLeft().scale(yScale);
      let xAxis = d3.axisBottom().scale(xScale);

      let lineGenerator = d3
        .line()
        .curve(d3[this.lineCurve])
        .x(function(d) {
          return xScale(d.name);
        })
        .y(function(d) {
          return yScale(d.value);
        });

      let pathData = lineGenerator(this.data);

      this.svg
        .append("path")
        .attr("d", pathData)
        .attr("stroke-width", 5)
        .attr("stroke", this.lineStrokeColor)
        .attr("fill", "none");

      let circles = this.svg.selectAll("circle").data(this.data);

      circles
        .enter()
        .append("circle")
        .attr("cx", function(d) {
          return xScale(d.name);
        })
        .attr("cy", function(d) {
          return yScale(d.value);
        })
        .attr("r", this.circleRadius)
        .attr("fill", this.circleColor)
        .on("mouseover", this.tip.show)
        .on("mouseout", this.tip.hide);

      circles.exit().remove();

      this.svg
        .append("g")
        .attr("transform", "translate(0,0)")
        .call(yAxis);

      this.svg
        .append("g")
        .attr("transform", "translate(0,300)")
        .call(xAxis)
        .selectAll("text")
        .style("text-anchor", "end")
        .attr("dx", "-.8em")
        .attr("dy", ".15em")
        .attr("transform", "rotate(-65)");
    }
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    width: {
      default: "600"
    },
    height: {
      default: "600"
    },
    yDomain: {
      type: Array,
      required: true
    },
    lineStrokeColor: {
      type: String,
      default: "red"
    },
    lineCurve: {
      type: String,
      default: "curveMonotoneX"
    },
    circleRadius: {
      type: Number,
      default: 4
    },
    circleColor: {
      type: String,
      default: "#fff222"
    },
    xRange: {
      default: () => [0, 400]
    }
  }
};
</script>

<style scoped>
svg {
  padding: 50px;
}
</style>
